import { acquireAccessToken, useAzureAuth } from "@datamole/wds-azure-auth";

import { MenuListItem, MenuListItemIcon } from "@/components/ui/MenuList";
import { notification } from "@/components/ui-deprecated";
import { config } from "@/config";
import { useAppSelector } from "@/store";

/**
 * Menu item for copying the authentication token to clipboard.
 * Only visible in developer mode and when a token is present.
 */
export const CopyAuthTokenMenuItem = () => {
    const { instance } = useAzureAuth();
    const { accessToken: adfsAccessToken, authStrategy } = useAppSelector((state) => state.auth);
    const developerMode = useAppSelector((state) => state.user.developerMode);

    if (!developerMode || !authStrategy) return null;

    const handleEntraIdTokenCopy = async () => {
        try {
            const token = await acquireAccessToken({ scopes: [config.AZURE_AUTH_SCOPE] }, instance);
            await navigator.clipboard.writeText(token);
            notification.success("Authentication token copied to clipboard");
        } catch {
            notification.warning("Failed to copy authentication token");
        }
    };

    // TODO: Remove once ADFS is deprecated and only Entra ID is supported
    const handleAdfsTokenCopy = async () => {
        try {
            await navigator.clipboard.writeText(adfsAccessToken ?? "");
            notification.success("Authentication token copied to clipboard");
        } catch {
            notification.warning("Failed to copy authentication token");
        }
    };

    const handleCopy = authStrategy === "entraId" ? handleEntraIdTokenCopy : handleAdfsTokenCopy;

    return (
        <MenuListItem onClick={handleCopy}>
            <MenuListItemIcon icon="lely-icon-copy" />
            Copy Authentication Token
        </MenuListItem>
    );
};
